<div class="container-fluid">
    <h2 class="heading_all">Attendence Register</h2>
    <div id="form-wrap" style="font-size: 12px;">
        <br>
        <div class="row" style="font-size: 16px;font-weight: bold;">
            <div class="col-md-4"></div>
            <div class="col-md-4" style="text-align: center;">
                <input type="month" id="start" name="start" min="2021-09" #start="ngModel" [(ngModel)]="this._AttandanceregisterService.selectedDate" (change)="getData()">
            </div>
            <div class="col-md-4 ">
                <div class="row">
                    <div class="col-md-6 ">Total Working Days:
                        {{_AttandanceregisterService.attandanceDetails.TotalWorkingDays}} </div>
                    <div class="col-md-6 "> Total Attandence
                        :{{_AttandanceregisterService.attandanceDetails.TotalAttandance}}</div>
                </div>
            </div>
        </div>
        <br>      
        <div class="tHead" [ngStyle]="{'height': _AttandanceregisterService.attandanceDetails.tableDetails.length == 3 ? '200' : '600' }">
            <table>
                <thead>
                    <tr *ngFor="let data of _AttandanceregisterService.attandanceDetails.tableDetails;let i =index;">
                        <ng-container *ngIf="i==0">
                            <th> SNO </th>
                            <th> Employee </th>
                            <ng-container *ngFor="let mnth of data.monthDays">
                                <th> {{mnth.Date |date:'EEE'}}
                                    <br>
                                    <span style="width: 100%; text-align: center;"> {{mnth.Date |date:'dd'}}</span>
                                </th>
                            </ng-container>
                            <th><b>Leave Balance <br>CL &nbsp;-&nbsp; CmtL</b> </th>
                            <th> CL</th>
                            <th> CmtL</th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of _AttandanceregisterService.attandanceDetails.tableDetails;let i =index;">
                        <ng-container *ngIf="i!=0 && (i+1)!=lastIndex">
                            <td> {{i}}</td>
                            <td title="{{data.Employee}}">{{data.Employee}}</td>
                            <ng-container *ngFor="let mnth of data.monthDays">
                                <td [ngClass]="{'offDay':mnth.DayType==2 &&  mnth.Value!='P','holiday':mnth.DayType==3 &&  mnth.Value!='P'}"
                                    [ngStyle]="{'color':  mnth.Value=='P'?'black':''}">{{mnth.Value}}</td>
                            </ng-container>
                            <td> <b>{{data.LeaveBalance}}</b></td>
                            <td> {{data.CL}}</td>
                            <td> {{data.CMTL}}</td>
                        </ng-container>
                    </tr>
                    <tr style="position:sticky; bottom: 0; z-index:1;  background-color:#209e91;"
                        *ngFor="let data of _AttandanceregisterService.attandanceDetails.tableDetails;let i =index;">
                        <ng-container *ngIf="(i+1)==lastIndex">
                            <td> </td>
                            <td> </td>
                            <ng-container *ngFor="let mnth of data.monthDays">
                                <td title="{{mnth.Value}}" style="color: black;" class="verticalTableHeader">
                                    <span>
                                        {{mnth.Value}}
                                    </span>
                                </td>
                            </ng-container>
                            <td> </td>
                            <td> </td>
                            <td> </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="margintop"></div>
</div>